import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Skeleton } from "@/components/ui/skeleton";

type Buckets = {
  '0-30': number;
  '31-60': number;
  '61-90': number;
  '90+': number;
};

type Props = {
  data: Buckets | undefined;
  isLoading: boolean;
  onBucketClick?: (bucket: string) => void;
};

const COLORS = ['#22c55e', '#f59e0b', '#f97316', '#ef4444'];

const fmt = (v: number) =>
  `$${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v.toFixed(0)}`;

export default function InvoiceAgingChart({ data, isLoading, onBucketClick }: Props) {
  const chartData = [
    { name: '0–30d', value: data?.['0-30'] ?? 0 },
    { name: '31–60d', value: data?.['31-60'] ?? 0 },
    { name: '61–90d', value: data?.['61-90'] ?? 0 },
    { name: '90+d', value: data?.['90+'] ?? 0 },
  ];

  return (
    <Card className="flex-1">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">Receivables Aging</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-40 w-full" />
        ) : (
          <ResponsiveContainer width="100%" height={160}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis tickFormatter={fmt} tick={{ fontSize: 11 }} width={48} />
              <Tooltip formatter={(v: number) => `$${v.toFixed(2)}`} />
              <Bar
                dataKey="value"
                radius={[3, 3, 0, 0]}
                cursor={onBucketClick ? 'pointer' : undefined}
                onClick={(d: { name: string }) => onBucketClick?.(d.name)}
              >
                {chartData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
